export enum TemplateKey {
    SimplifiedBasic = "com.pyxis.greenhopper.jira:gh-simplified-basic",
    Scrum = "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum",
    Kanban = "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban",
    WebDesignProcess = "com.atlassian.jira-core-project-templates:jira-work-management-web-design-process",
    GoToMarket = "com.atlassian.jira-core-project-templates:jira-work-management-go-to-market",
    SimplifiedProcessControl = "com.atlassian.jira-core-project-templates:jira-core-simplified-process-control",
    SalesPipeline = "com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline",
    SimplifiedProcurement = "com.atlassian.jira-core-project-templates:jira-core-simplified-procurement",
    EmployeeOnboarding = "com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding",
    PersonalTaskPlanner = "com.atlassian.jira-core-project-templates:jira-work-management-personal-task-planner",
    CampaignManagement = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management"
}
